// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/views/partials/products_type/archive/products_archive.scss
// module id = 79
// module chunks = 0